import CustomButton from "../components/CustomButton";
import providerImage from "../assets/images/ClineCo.png";
import BreadCrumbs from "../components/CustomBreadCrumbs";
import CustomBadges from "../components/CustomBadges";
import {
  CheckBadgeIcon,
  CheckCircleIcon,
  MapPinIcon,
  GlobeAltIcon,
} from "@heroicons/react/24/outline";
import CustomTabs from "../components/CustomTabs";
import { useNavigate, useParams } from "react-router-dom";
import { useGetProviderBasicProfile } from "../custom-hooks/queries";
import Skeleton from "react-loading-skeleton";
import CustomTooltip from "../components/Filters/CustomTooltip";
import Notification from "../components/Notification";
import { useEffect, useState } from "react";
import { getLocationFromProvider } from "../utils/addressUtils";
import { isBackendViewOnlyUser, useUserRole } from "../utils/helperMethods";

const ProviderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useGetProviderBasicProfile(id);
  const userRole = useUserRole();
  const hideRequestActions = isBackendViewOnlyUser(userRole);

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isError) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [isError]);

  return (
    <div className="w-full">
      {isLoading ? (
        <Skeleton className="w-full h-32" enableAnimation={true} />
      ) : (
        <div className="bg-gray-100 pt-6 pb-2 px-6 mt-[-8px] border-t border-gray-400">
          {/* Breadcrumbs */}
          <div className="flex justify-start mb-4">
            <BreadCrumbs breadcrumbs={data} />
          </div>

          {/* Content */}
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0 lg:space-x-4 mb-5">
            <div className="w-full lg:w-3/4 text-center lg:text-left">
              <h1 className="text-lg sm:text-xl font-bold text-custom-focus-color mb-1">
                {data?.logo ? (
                  <img
                    src={data?.logo}
                    alt="provider logo"
                    className="h-8 sm:h-10 inline-block"
                  />
                ) : (
                  <div className="text-custom-light-grey  font-semibold text-center">
                    <CustomTooltip sliceLength={50} cutOffAfter={30}>
                      {data?.name}
                    </CustomTooltip>
                  </div>
                )}
              </h1>

              {/* Centering service and location below the logo */}
              <div className="flex flex-col items-center lg:flex-row lg:items-start space-y-2 lg:space-y-0 lg:space-x-4 mt-5">
                {/* Globe icon */}
                <p className="text-gray-500 text-sm font-medium flex items-center justify-center lg:justify-start">
                  <GlobeAltIcon className="h-4 w-4 sm:h-5 sm:w-5 text-gray-500 inline" />
                  <span className="ml-2">{data?.provider_type}</span>
                </p>

                {/* Location */}
                <p className="text-gray-500 text-sm font-medium flex items-center justify-center lg:justify-start">
                  <MapPinIcon className="h-4 w-4 sm:h-5 sm:w-5 text-gray-500 inline" />
                  <span className="ml-2">
                      {getLocationFromProvider(
                        data?.provider_locations?.find(loc => loc?.location_type === "primary"),
                        { short: true, abbvState: true }
                      )}
                  </span>
                </p>
              </div>
            </div>

            {!hideRequestActions && (
              <div className="w-full lg:w-[30%] flex flex-col items-center lg:items-start space-y-4">
                <div className="flex flex-col  sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 w-full sm:w-auto items-center  ">
                  <CustomButton
                    color="bg-indigo-600"
                    size="text-base"
                    weight="font-normal"
                    height="h-9"
                    width="w-32"
                    textColor="text-white"
                    text="Request VQQ"
                    icon={<CheckCircleIcon className="h-5 w-5" />}
                    borderRadius="0.375rem"
                    onClick={() => navigate(`/RFI/Create?id=${id}`)}
                  />
                  <CustomButton
                    color="bg-red-400"
                    size="text-base"
                    weight="font-normal"
                    height="h-9"
                    width="w-44"
                    textColor="text-white"
                    text="Request Assessment"
                    icon={<CheckBadgeIcon className="h-5 w-5" />}
                    borderRadius="0.375rem"
                    onClick={() => navigate(`/Assessment/Create?id=${id}`)}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div>
        <CustomTabs Services={data} isLoading={isLoading} />{" "}
      </div>

      <Notification
        show={show}
        setShow={setShow}
        errorMessage={error?.message}
        status={"error"}
      />
    </div>
  );
};

export default ProviderDetails;
